import { useAuth } from "../context/AuthContext";
import { galleryCacheKey } from "../lib/api";
import { usePagedDucks } from "./usePagedDucks";

// "My Ducks": first 10 cards (cached per user, stale-while-revalidate) + load-more; `total` feeds the navbar badge.
export const useGallery = () => {
  const { user } = useAuth();
  const paged = usePagedDucks({ path: "/creations/page", pageSize: 10, cacheKey: galleryCacheKey(user?.id), enabled: !!user });
  return { gallery: paged.items, total: paged.total, loadGallery: paged.refresh, loadMore: paged.loadMore, hasMore: paged.hasMore, loadingMore: paged.loadingMore, patchGallery: paged.patchItem };
};
